import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';


export function fetchPaymentTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = `${DocType.PAYMENT_TYPE}/dropdown`
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchPaymentTypeForEdit(app, params) {
  const { id } = params;
  const docType = DocType.PAYMENT_TYPE;
  return common.getDoc(app, { id, docType });
}

export function deletePaymentType(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.PAYMENT_TYPE
  });
}

export function savePaymentType(app, dataToSave) {
  const { tenant, user = {}, data } = dataToSave;

  let paymentTypeData = {
    tenant: tenant.id,
    doc_type: DocType.PAYMENT_TYPE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    surcharge: util.toNumber(data.surcharge),
    system_defined: util.toBoolean(data.system_defined),
    symbol: util.toStringText(data.symbol),
    display_order: util.toInteger(data.display_order),
    credit_type_id: data.credit_type_id,
    allow_refund: util.toBoolean(data.allow_refund),
    available_offline: util.toBoolean(data.available_offline),
    allow_foreign_currency: util.toBoolean(data.allow_foreign_currency),
    allow_reversal: util.toBoolean(data.allow_reversal),
    allow_moto: util.toBoolean(data.allow_moto),
    cash_drawer_pop: util.toBoolean(data.cash_drawer_pop),
    color: util.toStringText(data.color),
    display_name: util.toStringText(data.display_name),
    icon: util.toStringText(data.icon),
    payment_methods: data.payment_methods,
    excluded_locations: util.toObjectIds(
      data.excluded_locations,
      data.excluded_locations_ids,
      'location_id',
    ),
    excluded_subsidiaries: util.toObjectIds(
      data.excluded_subsidiaries,
      data.excluded_subsidiaries_ids,
      'subsidiary_id',
    ),
    foreign_currencies: util.toObjectIds(
      data.foreign_currencies,
      data.foreign_currencies_ids,
      'currency_id',
    ),
    payment_device_types: util.toObjectIds(
      data.payment_device_types,
      data.payment_device_types_ids,
      'device_type_id',
    ),
    cash_rounding_reference_id: data.cash_rounding_reference_id,
    surcharge_item_id: data.surcharge_item_id,
    gratuity_item_id: data.gratuity_item_id,
    default: util.toBoolean(data.default),
    allow_change: util.toBoolean(data.allow_change),
    is_percent: data.is_percent === null ? false : util.toBoolean(data.is_percent)
  };
  return common.saveDoc(app, {
    source: data,
    doc: paymentTypeData,
    user
  });
}

export async function fetchAllPaymentTypes(app) {
  const result = await common.queryDocs(app, DocType.PAYMENT_TYPE, {
    limit: 100,
  });

  return result.data;
}
